import React, { useContext, useEffect, useState } from "react";
import { createSearchParams, useNavigate,useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*******INTERNAL IMPORTS********/
import { DisplaySpinnerContext } from "../../../context/ContextIndex";
import {
    DataGridTable,
    GridAction,
    FormPage
} from "../../../components-old/ComponentsIndex";
import { PricingPortalAPI } from "../../../apis/api-index";
import { MdCreate } from "react-icons/md";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import { useSelector } from "react-redux";
import { selectSessionConfig } from "../../../store/store-selector";
import { AppUtility } from "../../../utils/utility";

const GrossMarginLevelListForm = () => {
    /**************************************************
    //Form handlers & hooks
    **************************************************/
    const { t } = useTranslation();
    const navigate = useNavigate();
    const spinnerCtx = useContext(DisplaySpinnerContext);
    const settingsConfig = useSelector(selectSessionConfig);
    let { gmtype } = useParams();

    /**************************************************
    //Form state variables
    **************************************************/
    const [gmLevelRecordList, setGMLevelRecordList] = useState([]);
    const [dataGridPageSize, setDataGridPageSize] = useState(10);
    const [totalGMlevel, setTotalGMLevel] = useState(0);
    const [gridPageSizeOptions /*setGridPageSizeOptions*/] = useState([10, 20, 50]);


    /**************************************************
    //Event definitions
    **************************************************/

    //onclick of edit gross margin level
    const handleEditGMLevelClick = async (param) => {
        let _navigationData = param.recordResponse;
        _navigationData.gmtype = gmtype ? gmtype : "gmsales";
        _navigationData.gmLevelList = gmLevelRecordList;
        delete _navigationData.CreatedDate;
        delete _navigationData.ModifiedDate;
        delete _navigationData.CountryCode;
        delete _navigationData.BusinessCode;

        navigate(
            {
                pathname: "/grossmarginlevel",
                search: createSearchParams({
                    HashId: param.recordResponse.HashId,
                }).toString(),
            },
            { state: _navigationData }
        );
    };

    //on page change
    const handlePageSizeChange = (newPageSize) => {
        setDataGridPageSize(newPageSize);
    };

    //show review modal
    const handleShowSelectedGMLevelChanges = (event) => {
        let _navigationData = { previousPath: `/${gmtype}` };
        navigate(
            {
                pathname: "/reviewdetails",
                search: createSearchParams({
                    reviewFilter: `&locationkey=${event.id}`,
                }).toString(),
            },
            { state: _navigationData }
        );
    };

    /**************************************************
    //Fetch API & utility
    **************************************************/


    const setGMLevelList = (gmLevelList) => {
        try {
            gmLevelList.sort((a, b) => a.GMLevel - b.GMLevel);
            let _gmLevelList = gmLevelList.map((item) => {
                return {
                    id: item.HashId,
                    hashId: item.HashId,
                    gmLevel: item.GMLevel,
                    startRange: `${item.GrossMarginMinPercent} ${item.GMType === "GMPERCENTILE" ? "%" : ""}`,
                    endRange: `${item.GrossMarginMaxPercent} ${item.GMType === "GMPERCENTILE" ? "%" : ""}`,
                    recordResponse: item
                };
            });

            setGMLevelRecordList(_gmLevelList);
            setTotalGMLevel(_gmLevelList.length);
            spinnerCtx.setLoadingIndicator(false);
        } catch (err) {
            spinnerCtx.setLoadingIndicator(false);
            alert(err);
        }
    };

    const FetchGMLevelList = async () => {
        try {
            gmtype = gmtype ? gmtype : "gmsales";
            let _lists = await PricingPortalAPI.getFilterList(
                settingsConfig.businessCode,
                settingsConfig.countryCode,
                "getGMLevelList",
                "grossmarginlevel",
                `&gmtype=${gmtype.toUpperCase()}`
            );
            setGMLevelList(_lists);
        } catch (err) {
            alert(err);
        }
    };

    /**************************************************
    //JSX delcaration
    **************************************************/

    //data grid schema
    const dataGridSchema = [
        {
            field: "gmLevel",
            headerName: t("gmLevelList.gmLevel"),
            flex: 2,
        },
        {
            field: "startRange",
            headerName: t("gmLevelList.startRange"),
            flex: 2,
        },
        {
            field: "endRange",
            headerName: t("gmLevelList.endRange"),
            flex: 2,
        },
        {
            field: "recordResponse",
            hide: true,
        },
        {
            field: "action",
            headerName: t,
            flex: 1,
            sortable: false,
            renderCell: (params) => {
                return (
                    <GridAction actionsConfig={actionConfigs} row={params.row} />
                );
            },
        },
    ];

    //button configs for add and download list
    const buttonConfigs = [
        {
            buttonText: <SystemUpdateAltIcon />,
            buttonType: "outlined",
            onClick: () => {
                AppUtility.handleDownload(gmLevelRecordList, "GMLevel.xlsx");
            },
            buttonColor: "#A62B23",
            textColor: "#A62B23",
            action: "download"
        },
    ];

    //action configs for edit record
    const actionConfigs = [
        {
            onClick: handleShowSelectedGMLevelChanges,
            action: "review"
        },
        {
            icon: MdCreate,
            onClick: handleEditGMLevelClick,
            buttonColor: "#EEEEE",
            action: "edit"
        }
    ];


    /**************************************************
    //Form on load useEffect
    **************************************************/
    useEffect(() => {
        spinnerCtx.setLoadingIndicator(true);
        FetchGMLevelList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gmtype]);

    return (
        <FormPage isList={true}>
            <DataGridTable
                rows={gmLevelRecordList}
                columns={dataGridSchema}
                pageSize={dataGridPageSize}
                pageSizeOptions={gridPageSizeOptions}
                onPageSizeChange={handlePageSizeChange}
                totalRowCount={totalGMlevel}
                toolbarHeader={gmtype === "gmsales" ? t("gmLevelList.gmSalesHeader") : t("gmLevelList.gmPercentileHeader")}
                toolbarFilterPlaceholder={t("quoteApproval.toolbarFilterPlaceholder")}
                buttonConfigs={buttonConfigs}
            />
        </FormPage>
    );
};

export default GrossMarginLevelListForm;
